// https://github.com/eslint/eslint/issues/12822
/* eslint-disable chai-friendly/no-unused-expressions */
import global from './global.js';
export default ({ type, payload }) => {
    var _a, _b;
    ;
    (_b = (_a = global === null || global === void 0 ? void 0 : global.analytics) === null || _a === void 0 ? void 0 : _a.track) === null || _b === void 0 ? void 0 : _b.call(_a, type, payload);
};
export const analyticsPage = ({ type, payload }) => {
    var _a, _b;
    ;
    (_b = (_a = global === null || global === void 0 ? void 0 : global.analytics) === null || _a === void 0 ? void 0 : _a.page) === null || _b === void 0 ? void 0 : _b.call(_a, type, payload);
};
export const analyticsIdentify = ({ type, payload }) => {
    var _a, _b;
    ;
    (_b = (_a = global === null || global === void 0 ? void 0 : global.analytics) === null || _a === void 0 ? void 0 : _a.identify) === null || _b === void 0 ? void 0 : _b.call(_a, type, payload);
};
//# sourceMappingURL=track.js.map